import { z } from 'zod';
import {
  MetaCustomEventSchema,
  MetaStandardEventSchema,
} from './marketing-events';

// 1. Origen del Evento
export const EventSourceSchema = z.enum([
  'client_browser',
  'admin_dashboard',
  'system_automated',
]);

// 2. Identificación Interna
export const UserIdentificationSchema = z.object({
  phone: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  email: z.string().email().nullable().optional(),
  fbp: z.string().nullable().optional(),
  fbc: z.string().nullable().optional(),
  externalId: z.string().nullable().optional(),
});

export const InternalEventValueSchema = z.object({
  amount: z.number().min(0),
  currency: z.literal('USD').default('USD'),
  itemName: z.string().optional(),
  itemCategory: z.string().optional(),
  itemId: z.string().optional(), // 👈 Añadido
  // Guardamos un snippet de la descripción para análisis de copy
  descriptionSnippet: z.string().optional(),
});

// 4. Tracking Payload (El que viaja por el Hook y el Dispatcher)
export const MarketingTrackingPayloadSchema = z.object({
  salonId: z.string(),
  eventName: z.union([MetaStandardEventSchema, MetaCustomEventSchema]),
  user: UserIdentificationSchema,
  value: InternalEventValueSchema.optional(),
  eventId: z.string(),
  source: EventSourceSchema,
  eventSourceUrl: z.string().optional(),
  testEventCode: z.string().optional(),
});

// --- EXPORTACIÓN DE TIPOS ---
export type EventSource = z.infer<typeof EventSourceSchema>;
export type UserIdentification = z.infer<typeof UserIdentificationSchema>;
export type EventValue = z.infer<typeof InternalEventValueSchema>;
export type MarketingTrackingPayload = z.infer<
  typeof MarketingTrackingPayloadSchema
>;
